import { TableView } from "./types";
import { t } from "i18next";

export const initialTableViewState: TableView = {
  viewErrorMessage: "",
  isViewEditMenu: false,
  dynamicTableViewId: null,
  dynamicTableViews: null,
  rowHeight: { name: t("TableViewInitializes.小"), value: 36, key: "short" },
  hidden: [],
};
